// Обхватът на времевата линия за показания ден — чиста логика без React
// (тестове: timelineDay.test.ts).

import type { OpenTable, Reservation } from "../../../api/reservations";
import { minuteOfDay, timelineRange, toDateKey, type TimelineRange } from "./dayTime";

/**
 * Линията започва от 11:00 или от по-ранния момент на деня `dateKey`:
 * часа на резервация, настаняване, отваряне на сметка или „сега" (всичко —
 * само ако е в същия локален ден; вчерашна сметка не мести началото).
 */
export const dayTimelineRange = ({
  dateKey,
  reservations,
  openTables,
  nowMs,
}: {
  dateKey: string;
  reservations: Reservation[];
  openTables: OpenTable[];
  nowMs: number;
}): TimelineRange => {
  const minutes: number[] = [];
  const add = (moment: number) => {
    if (Number.isFinite(moment) && toDateKey(new Date(moment)) === dateKey) minutes.push(minuteOfDay(moment));
  };
  for (const reservation of reservations) {
    add(Date.parse(reservation.startAt));
    if (reservation.seatedAt) add(Date.parse(reservation.seatedAt));
  }
  for (const bill of openTables) add(Date.parse(bill.openedAt));
  add(nowMs);
  return timelineRange(minutes);
};
